import React from 'react'
import {Button, Dialog, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import {InventoryCorrectionReasonLabels, inventoryCorrectionReasons,} from '../constants/securspace-constants';
import CorrectionComparison from './CorrectionComparison';
import {getDates} from "../../views/inventory-correction/util";
import {CorrectionBtnGroup, CorrectionReason} from "../../views/inventory-correction/styles";

const ReviewModal = (props) => {
  const {
    inventoryCorrection,
    handleClose,
    showNewBookingNumberForm,
    onRetract,
    handleAccept,
    handleReject,
    openModal,
    isSupplier
  } = props

  const reason = inventoryCorrection?.reason;
  const hasPendingStatus = inventoryCorrection?.status === 'PENDING';

  const buyerCorrectionMessage = reason ? InventoryCorrectionReasonLabels.find(item => item.value === reason).label : '';
  const reasonRejected = inventoryCorrection?.status === 'REJECTED' ? inventoryCorrection?.rejectionReason : '';
  const buttonText = isSupplier ? 'Cancel' : 'Close';

  const handleSelectAccept = () => {
    if(reason === inventoryCorrectionReasons.ASSET_DOES_NOT_BELONG_TO_BUYER) {
      showNewBookingNumberForm()
    } else {
      handleAccept()
    }
  }

  return (
    <Dialog open={openModal} onClose={handleClose}
        fullWidth={false}
        maxWidth={'sm'}>
      <DialogTitle variant={'h6'}>
        Review Inventory Correction
      </DialogTitle>
      <DialogContent>
        <Grid container flexDirection="column" rowSpacing={2} marginTop={"1em"}>
          <Grid item>
            <CorrectionReason>Status: {inventoryCorrection?.status}</CorrectionReason>
          </Grid>
          {!isSupplier && reasonRejected !== '' &&
            <Grid item>
              <CorrectionReason>Reason: {reasonRejected}</CorrectionReason>
            </Grid>
          }
          <Grid item>
            <Typography>Buyer's Response:  </Typography>
          </Grid>
          <Grid item>
            <CorrectionReason>{buyerCorrectionMessage}</CorrectionReason>
          </Grid>
          <Grid item>
            <Typography>Buyer's Notes:</Typography>
            <CorrectionReason>{inventoryCorrection?.notes}</CorrectionReason>
          </Grid>
          <CorrectionComparison
            inventoryCorrection={inventoryCorrection}
            getDates={() => getDates(inventoryCorrection)}
          />
        </Grid>
      </DialogContent>
      <CorrectionBtnGroup>
        <Button
          variant="text"
          onClick={handleClose}
          color="secondary">
          {buttonText}
        </Button>
        {
          onRetract && hasPendingStatus ?
            <Button
              variant="text"
              onClick={() => onRetract(inventoryCorrection.id)}
              color="secondary">
              Retract This Correction
            </Button>
          : ""
        }
        {isSupplier &&
          <Grid item container justifyContent="flex-end" columnGap={1.5}>
            <Button onClick={handleSelectAccept} variant='outlined'>Accept</Button>
            <Button onClick={handleReject} variant='outlined'>Reject</Button>
          </Grid>
        }
      </CorrectionBtnGroup>
    </Dialog>
  )
}

export default ReviewModal;
